import React, { useEffect } from "react"
import { useFetch } from "hooks/use-new-fetch"
import { Text } from "@convertkit/slate"
import { useEditor } from "../../editor-context"
import Tweet from "./tweet"
import { toast } from "@kit/design/toast"

/**
 * getTweetId accepts a URL like https://twitter.com/jack/status/123456 and
 * returns the id ("123456").
 *
 * @param {String} url
 * @returns {String}
 */

export function getTweetId(url) {
  // Remove UTM params.
  url = url.split("?")[0]

  // Remove the trailing slash.
  url = url.endsWith("/") ? url.slice(0, -1) : url

  // Get the last part of the URL (the ID).
  const id = url.split("/").pop()

  return id || ""
}

function TweetNode({ node, attributes, data }) {
  const editor = useEditor()
  const id = data.tweetId
  const [request] = useFetch(`/tweets/${id}`)

  useEffect(() => {
    if (!editor) return
    if (data.tweet) return
    if (!id) {
      toast({ type: "error", text: "The tweet URL is invalid." })
      return
    }
    request.get().then(({ data: response }) => {
      if (response.error) {
        editor.removeNodeByKey(node.key)
        editor.insertLink({ href: data.href })
        toast({ type: "info", text: response.error })
        return
      } else if (response && response.id) {
        editor.setNodeByKey(node.key, {
          data: { ...data, tweet: response }
        })
      }
    })
  }, [editor])

  const tweet = data.tweet

  if (!tweet) return <div {...attributes} />

  return <Tweet data={data} attributes={attributes} node={node} />
}

export default {
  component: TweetNode,
  email: Tweet,
  schema: {
    isVoid: true
  },
  commands: {
    insertTweet: (editor, { href, ...attributes }) => {
      const tweetId = getTweetId(href)

      editor.insertBlock({
        type: "tweet",
        data: { href, tweetId, ...attributes },
        nodes: [Text.create("")]
      })
    }
  }
}
